module.exports = __webpack_public_path__ + "img/100h100_gluhoe.86c1eafc.svg";